import React from 'react';
import ElectrolysersTech from '../components/technology/ElectrolysersTech';
import Breadcrumbs from '../components/Breadcrumb';
import CommonBanner from '../components/CommonBanner';

const Technology = () => {
  const breadcrumbItems = ['Technology', 'Electrolysers'];

  return (
    <div>
      <div className='mt-16 sm:mt-20 md:mt-24 lg:mt-24 mx-6 sm:mx-8 md:mx-10 lg:mx-20'>
        <Breadcrumbs item1={breadcrumbItems[0]} item2={breadcrumbItems[1]} />
      </div>
      <div className="border-b border-gray-200 mt-2"></div>

      <div>
        <CommonBanner 
          topTitle="Our Tech"
          bannerImage="https://images.unsplash.com/photo-1622801026801-f7c7b305026f?q=80&w=2877&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          bannerImageAlt="Dyralyze Carbon-free Energy"
          bannerTitle="Green Molecules Electrolysers"
          welcomeTitle="Revolutionizing Green Energy with Electrolyser Technology"
          welcomeDescription="At Duralyze, we're revolutionizing green energy with our advanced electrolyser technology. Designed 
          for efficiency and reliability, it outperforms conventional systems and meets both today's and tomorrow's needs. "
        />
        <ElectrolysersTech />
      </div>
    </div>
  )
}

export default Technology;
